import { graphql } from '@/graphql-setup'

export const TimesheetFragments = {
  absenceInfo: graphql(`
    fragment AbsenceInfo on AbsenceNode {
      id
      absenceType {
        id
        name
      }
      datetimeStart
      datetimeEnd
      reason
    }
  `),
  timeEntryInfo: graphql(`
    fragment TimeEntryInfo on TimeEntryNode {
      id
      datetimeStart
      datetimeEnd
      project {
        id
        name
      }
      comment
      pause
      overtime
      totalWork
    }
  `),
}
